import React, { useState } from 'react'
import { connect } from 'react-redux'
import { collapseLeftToolbar } from '../../../../../action/left-toolbar-state-actions'
import { markerCreateRequest } from '../../../../../action/marker-actions'
import SetIdealWinds from '../../../common/hunt-wind/set-ideal-wind'
import MarkerDetails from '../../common/marker-details'
import TooManyObjects from '../../common/tooMany-object'
import { showHideSubscriptionModal } from '../../../../../utils/subscriptionUtils'

const AddStand = (props) => {
  const [markerData, setMarkerData] = useState(null),
    [winds, setWinds] = useState([]),
    [saving, setSaving] = useState(false),
    [standSaved, setSaved] = useState(false),
    [tooManyObjects, setTooManyObjects] = useState(false)

  const cancelUpgrade = () => {
    props.collapseLeftToolbar()
  }

  const handleUpgrade = () => {
    let accessToken = props.auth
    showHideSubscriptionModal(accessToken)
  }



  const saveMarker = () => {
    setSaving(true)
    const markerObj = Object.assign({}, markerData)
    markerObj['extendedData'] = `{"huntStandData": {"preferredWindDirections": ${JSON.stringify(winds)}}}`
    async function handleMarkerCreateRequest() {
      try {
        const res = await props.markerCreateRequest(markerObj)
        setSaved(true)
        props.mapReference.setCenter({ lat: parseFloat(markerObj.latitude), lng: parseFloat(markerObj.longitude) })
      } catch (error) {
        console.log(error, 'Error is occured at markerCreateRequest')

        if (error.status == 400) {
          setTooManyObjects(true)
        } else {
          collapseLeftToolbar()
        }

      }
    }
    handleMarkerCreateRequest()
  },
    reset = () => {
      setSaving(false)
      setSaved(false)
      setWinds([])
      setMarkerData(null)
    }
  return (
    <div>
      {markerData === null ?
        <MarkerDetails category={6} usageFlag={3} type='addStand' setMarkerData={setMarkerData} /> :
        !standSaved ? <SetIdealWinds winds={winds} setWinds={setWinds} saveMarker={saveMarker} markerData={markerData} setMarkerData={setMarkerData} /> :
          null
      }
      {
        saving ? (
          <div style={{ padding: '10px' }}>
            <div className='hunt-wind-header'>
              {standSaved ? 'STAND SAVED SUCCESSFULLY' : 'SAVING STAND'}
            </div>
            {
              standSaved ? (
                <div>
                  <p className='hunt-wind-prompt'></p>
                  <div style={{ display: 'flex' }}>
                    <button style={{ width: '50%', backgroundColor: '#959595' }}
                      onClick={() => {
                        props.collapseLeftToolbar()
                      }}>CLOSE</button>
                    <button style={{ width: '50%' }} onClick={reset}>NEW STAND</button>
                  </div>
                </div>
              ) : (
                <div style={{ width: '100%', marginBottom: '10px' }}>
                  <img className="horizontal-center dialog-spinner"
                    src="../../../asset/loading-spinner.gif"></img>
                </div>
              )}
          </div>
        ) : null
      }

      {tooManyObjects ?
        <TooManyObjects
          cancel={cancelUpgrade}
          upgrade={handleUpgrade}
        /> :
        null
      }
    </div >
  )
}

const mapStateToProps = state => ({
  mapReference: state.mapReference(),
  auth: state.auth
})

const mapDispatchToProps = dispatch => ({
  markerCreateRequest: marker => dispatch(markerCreateRequest(marker)),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar())
})

export default connect(mapStateToProps, mapDispatchToProps)(AddStand)